<template>
    <router-view />
</template>

<script>
import ApiService from "../../api/api.service";

export default {
    name: "Projects",
    data: function () {
        return {
            projects: [],
        }
    },
    mounted() {
        if(this.$route.name != 'Projects') {
            return;
        } else {
            this.getProjects();
        }
    },
    watch: {
        $route(to, from) {
            if (to.name == 'Projects') {
                this.getProjects();
            }
        }
    },
    methods: {
        getProjects() {
            ApiService.setHeader();
            ApiService.get('/api/projects')
                .then(({data}) => {
                    this.projects = data.projects;

                    let route = null;
                    if(data.projects.length) {
                        route = { name: 'Project Management'};
                    } else {
                        route = { name: 'Create Project Intro'};
                    }
                    this.$router.push(route);
                })
                .catch((response) => {
                    console.log(response);
                });
        }
    }
}
</script>

<style scoped>

</style>
